export type SortDirection = 'asc' | 'desc';

export function sortBy<T>(a: T, b: T, key: keyof T, direction: SortDirection = 'asc'): number {
  const aValue = a[key];
  const bValue = b[key];

  if (typeof aValue === 'string' && typeof bValue === 'string') {
    // String comparison
    const comparison = aValue.localeCompare(bValue);

    if (comparison !== 0) {
      return direction === 'asc' ? comparison : -comparison;
    }
  } else if (typeof aValue === 'number' && typeof bValue === 'number') {
    // Number comparison
    return direction === 'asc' ? aValue - bValue : bValue - aValue;
  }

  return 0;
}
